<div class="p-4 max-h-full overflow-y-auto">
  <ng-template [cdkPortalOutlet]="portal"></ng-template>
</div>
